"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const constants_1 = require("modules/app/services/datahub/constants");
const DatahubService_1 = __importDefault(require("modules/app/services/datahub/DatahubService"));
const helper_1 = require("modules/app/services/datahub/helper");
class DatahubClassSortingService {
    constructor() {
        this.sendClassSortingEvent = (category) => {
            DatahubService_1.default.sendEvent({
                action: constants_1.EVENT_ACTIONS.INTERACT,
                event: (0, helper_1.buildInteractionEventData)({
                    category,
                    action: constants_1.EVENTS_INTERACTIONS.CLICK
                })
            });
        };
    }
}
exports.default = new DatahubClassSortingService();
